import styled from 'styled-components';

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HeaderTitle = styled.div`
  padding: 12px 20px;
  font-size: 20;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
`;

export const ContainerInternoCheckNav = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerStyledRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ContainerInternoCheck = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerInternoInput = styled.div`
  z-index: 0;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerInterno = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerInternoNav = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerInternoRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-width: 40%;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerInternoLinha = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 20px;
`;

export const ContainerLogoTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin: 10px;
`;

export const SubTitle = styled.h5`
  color: ${({ theme }) => theme.colors.text};
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.text};
`;

export const LabelSmall = styled.label`
  color: ${({ theme }) => theme.colors.text};
  font-size: 11px;
  font-style: italic;
  font-weight: 600;
  margin-left: 4px;
`;

export const FlexRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;
